import { Component, Inject, OnInit, ViewChild , NgZone} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {_} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { UrlInfo, CountryOption, StateOption, UserInputs } from './new-user.interfaces';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { BroadCastService } from '../../services/broadcast.service';
import { MySynchEnumerationService } from '../../services/mysynch.enumeration.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext} from '../../interfaces/mysynch.interfaces';

@Component({
  standalone: false,
  selector: 'new-user',
  templateUrl: '../app/pages/new-user/new-user.view.html',
  styleUrls: ['../app/pages/new-user/new-user.style.css']
})
export class NewUser implements OnInit {
  
  @ViewChild('newUserForm') newUserForm: NgForm;
  
  
  _: any;
  isMobile:boolean = this.deviceDetector.isMobile();
  private performanceContext: PerformanceContext | null = null;
  // Parse the fragment manually
  private fragment:string = this.route.snapshot.fragment || '';
  private urlInfo:UrlInfo = this.parseUrlFragment(this.fragment);
 
  //url parameters
  private authHeaderTokenString: string = this.urlInfo.authHeaderTokenString;
  private personKey = this.urlInfo.personKey;
  private farmId = this.urlInfo.farmId;
  private newUser: any = {};
  private view: any = {currentFarm: null};
  private orginalEmail: string = null;

  loading:boolean = true;
  lookupLists: any[] = [];
  codeFile:any[] = [];
  personTypes: any[] = [];
  countries: CountryOption[] = [];
  states: StateOption[] = [];
  statesAndProvinces: any[] = [];
  inputs: UserInputs = { EULAAcceptedOn: null };


  saving = false;
  emailInUse = false;
  previousEmail = '';

  

  constructor(
    @Inject('MySynchFactory') private MSF: any,
    @Inject('ApiFactory') private api: any,
    @Inject('CookieFactory') private cookies: any,
    @Inject(MySynchConstantService) private mysynchConstantsSvc: MySynchConstantService,
    @Inject(MySynchEnumerationService) private mySynchEnumSvc: MySynchEnumerationService,
    @Inject(BroadCastService) private broadCastSrv: BroadCastService,
    @Inject(ActivatedRoute) private route: ActivatedRoute,
    @Inject(NgZone) private zone: NgZone,
    @Inject(DeviceDetectorService) private deviceDetector: DeviceDetectorService,
    @Inject(PerformanceMetricsService) private perfMetricsSvc: PerformanceMetricsService,
    @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
    @Inject(ClientLoggerService) private log:ClientLoggerService
  ) {
    this._ = _;
    this.emailMatches = this.emailMatches.bind(this);
    this.parseUrlFragment = this.parseUrlFragment.bind(this);

   
  }

  // Helper function to parse the fragment
  private parseUrlFragment(fragment: string): UrlInfo {
    // Split the fragment into path and query parts
    const fragmentParts = fragment.split('?');
    const path = _.first(fragmentParts) || '';
    const queryString = _.last(fragmentParts) || '';

    const pathParts = _.compact(path.split('/'));
    const personKey = _.get(pathParts,"[1]",'');
    let farmIdPart = _.get(pathParts,"[2]",'');
    let farmId: number | null = null;
    if(!_.isEmpty(farmIdPart) && !_.isNaN(Number(farmIdPart))){
       farmId = Number(farmIdPart);
    }
  
    const paramStrings = queryString.split('&');
    const authHeaderTokenStringParamString = _.first(paramStrings) || '';
    const authHeaderTokenStringParamAssignOperatorIndex = _.indexOf(authHeaderTokenStringParamString, '=');
    const authHeaderTokenString = this.MSF.decodeBase64StringFromUrl(authHeaderTokenStringParamString.substring(authHeaderTokenStringParamAssignOperatorIndex + 1));

    return {
      personKey: personKey,
      farmId: farmId,
      authHeaderTokenString: authHeaderTokenString
    } as UrlInfo;

  }

 

  private loadUserAndFarmData(): void {
    const promises: Promise<any>[] = [];

   
    promises.push(new Promise((resolve, reject) => {
        // this.zone.run(() => {
        this.MSF.logout();
        
      // });
      this.perfMetricsSvc.startTiming("Page:NewUserPersonData:Request");
      this.api.getUserByPersonKey(this.personKey, (err, person) => {
        this.perfMetricsSvc.endTiming("page","Page:NewUserPersonData:Request", this.performanceContext);
        
          if(err){
            this.log.error('Error getting user: ' + err);
            reject(err);
            return; 
          }
          //this.zone.run(() => {

              if (!person) {
                this.MSF.loadPage('Login');
                reject('No person found');
                return;
              }
    
              if(this._.isNull(this._.get(person,"country"))){
                  this._.set(person,"country", _.get(this.inputs,"country",''));
              }

              this.inputs = this._.extend({}, this.inputs, person);
              this.inputs.confirmEmail = '';
              this.inputs.password = '';
              this.orginalEmail = this._.get(person, 'email', '');

              // initialize personType  
              const personType = this._.get(this.inputs,"personTypeId",null);

              // Clear "Other" PersonType, provide the default the first one in the list , but the user can change it
              // to any other person type in the list.
              if (this._.isEqual(this.inputs.personTypeId, 6) || this._.isNull(personType)) {
                this.inputs.personTypeId = _.get(_.first(this.personTypes), 'personTypeId', null);
              }
             
              this.log.info('user gotten');
              resolve(person);
            // });
        });
    }));

        if(!this.MSF.isNullish(this.farmId)){
            promises.push(new Promise((resolve, reject) => {
              this.perfMetricsSvc.startTiming("Page:NewUserFarmData:Request");
              this.api.getFarm(this.farmId,(err, farm) => {
                this.perfMetricsSvc.endTiming("page","Page:NewUserFarmData:Request", this.performanceContext);
              //  this.zone.run(() => {
              
                  if(!this._.isUndefined(err) && !this._.isNull(err)){	
                    this.log.error(this.MSF.notify.danger('Error getting farm: ' + err));
                    resolve(null);
                  
                  }else{
                    this.view.currentFarm = farm;
                    this.log.info('farm gotten');
                     resolve(farm);
                  }
              });  
            }));
        }

        Promise.all(promises)
        .then(() => {
          this.log.info('[DEBUG] All user/farm data loaded');
          this.loading = false; // ✅ Single control point
        })
        .catch((err) => {
          this.log.error('[DEBUG] Error loading user/farm data:', err);
          this.loading = false; // Still allow page to render on error
          this.MSF.notify.danger('Some user data failed to load. Please contact support if the problem persists. ' + err);
        });

      }

  private loadSelectOptions(): void {
    
    this.api.getUnCachedStaticListData((err, data) => {
      if (err) {
        this.log.error('Error loading static list data:', err);
        this.MSF.notify.danger('Countries and States failed to load. Please contact support if the problem persists. ' + err);
        this.loading = false; // Allow page to render even if select options fail to load
        return;
      }
     // this.zone.run(() => {
        this.lookupLists = this._.cloneDeep(data);

        this.codeFile = _.get(this.lookupLists,"codeFile",[]);
        this.personTypes = this._.get(this.lookupLists,"personType",[]);
      
        this.loadCountryList();
        this.loadStateList();

        
				_.set(this.inputs,"country", _.get(_.find(this.countries,{codeValue: this.mysynchConstantsSvc.defaultUserCountry}), 'codeValue', ''));
				
   //   });

       if (this.personKey) {
          this.MSF.logout();
          this.loadUserAndFarmData();
        } else {
          this.MSF.loadPage('Login');
        }
    });
  }

  private loadCountryList(): void {
    const countries = this._.map(
      this._.filter(this.codeFile, {codeType: "COUNTRY"}),
      (countryItem) => {
        return this._.pick(countryItem,["id","code","codeValue","dropDownSeq"]);
      });  
    this.countries = countries;
  }

  private loadStateList(): void {
    const allStatesAndProvinces = this.MSF.getCodeFileSubsetWithParsedDetailsJson(
      this._.filter(this.codeFile, 
                    (codeFileItem) => this._.includes(['STATE', 'PROVINCE'], this._.get(codeFileItem, 'codeType'))
                   )
    );

    this._.forEach(this.countries, (country)=>{
					
      var countryCode = _.get(country,'code');
      var countryCodeValue = _.get(country,'codeValue');

      var stateList = {
        country : countryCodeValue,
        states: _.map(_.filter(allStatesAndProvinces,(stateAndProvinceItem)=>{
                return _.isEqual(_.get(stateAndProvinceItem,'detailsJson.country'),countryCode);
                }),
                function (stateItem){
                  return _.pick(stateItem,["id","code","codeValue","dropDownSeq"]);
                }
              )
      }

      this.statesAndProvinces.push(stateList);
    });
				
    var userCountry = _.get(this.inputs,'country');
    if(!this.MSF.hasValue(userCountry)){
      userCountry = this.mysynchConstantsSvc.defaultUserCountry;
    }
    this.setStateList(userCountry);
  }

  private resetStateDropdown(): void {
    //this.broadCastSrv.clearControlMsg('state');
    this.inputs.state = null;
  }
  
  // sets the options available in the states dropdown
  private setStateList(country):void{      
    var states = this._.get(this._.find(this.statesAndProvinces,{country: country}),'states',[]) ;
    this.states = states;     
  }

  onCountryChange(country: string): void {
    this.setStateList(country);
    this.resetStateDropdown();
  }


  termsAndPrivacyInNewWindow() {
    window.open('https://parnell.com/mysynch-terms-conditions/', '_blank');
    this.inputs = {
      EULAAcceptedOn: null		///TODO: Could be set to Date(), or get this date from server (awaiting confirmation from Angela / Kelly)
    };
  };

  duplicateUsername() {
    return this.emailInUse && (this.inputs.email || '').toLowerCase() == (this.previousEmail || '').toLowerCase();
  };

  emailMatches() {
    if(this.newUserForm && this.newUserForm.form.controls.confirmEmail && this._.get(this.newUserForm,"form.controls.confirmEmail.dirty",false))
    {
      return this._.isEqual(this.inputs.email, this.inputs.confirmEmail);
    }else{
      return true;
    } 
  }; 


  save(): void {
    if (!this.newUserForm.form.valid) {
        this.newUserForm.form.markAllAsTouched();
        return;
    }

    this.emailInUse = false;
    this.previousEmail = this.inputs.email;
    this.saving = true;

    this.api.loginAvailable(this.inputs.personTypeId, this.inputs.email, (err, result) => {
      if (err) {
        this.log.error('Error checking loginId availability ' + err);
        this.saving = false;

        return this.MSF.notify.danger('Unable to save changes');
      }

      // fail the save if the email is already in use and 
      // the email is different from the original email when the user was created
      if (!result.available && !this._.isEqual(this.inputs.email, this.orginalEmail)) {
        this.log.info('requested loginId is unavailable');
        
          this.previousEmail = this.inputs.email;
          this.emailInUse = true;
          this.saving = false;
        
        return;
      }
      let activateUserData = this._.extend({}, this.inputs, {status: this._.get(this.mySynchEnumSvc.getMySynchEnumeration('PersonStatus','ACTIVE'),'value')});
      
      this.api.activateUser(activateUserData, (err, person) => {
        this.saving = false;
        if (err) {
          return this.log.error(this.MSF.notify.danger('Error updating user ' + err));
        } 
        // now that the user has confirmed their profile, we can clear the temp authorization token
        this.cookies.clear("user");	
        this.MSF.notify.success('Registration successful, please login');
        this.MSF.loadPage('Login');

      });
    });
  }
  ngOnInit() {
    this.MSF.ready(()=> {
      this.performanceContext = this.perfContextSvc.createPerformanceContext();
      this.perfMetricsSvc.startTiming("Page:NewUser:Render");
      this.perfMetricsSvc.startTiming("Page:NewUser:Build");

       // in order for api calls to work on this page, we need to set the authTokenString to the cookie.user
			// first clear previous cookie.user value
			this.cookies.clear("user");

			// set the authTokenString to the cookie.user
			this._.set(this.cookies.user,'token',this.authHeaderTokenString);
			this.cookies.save();

      this.loadSelectOptions();

      this.perfMetricsSvc.endTiming("page","Page:NewUser:Build", this.performanceContext);
      this.perfMetricsSvc.markPageReady("Page:NewUser:Render", this.performanceContext);

  });
}
}